const BusinessEntityRefresh = (BusinessEntityId: string, func) => {
    if (BusinessEntityId) {
        return func()
    }
}

export default BusinessEntityRefresh
